'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ALWAYS_AVAILABLE = 999999;

var HoldCounts = function HoldCounts(_ref) {
  var availableCopies = _ref.availableCopies,
      heldCopies = _ref.heldCopies,
      totalCopies = _ref.totalCopies,
      _ref$localeKey = _ref.localeKey,
      localeKey = _ref$localeKey === undefined ? 'holdCount' : _ref$localeKey,
      _ref$tagElement = _ref.tagElement,
      tagElement = _ref$tagElement === undefined ? 'span' : _ref$tagElement,
      props = _objectWithoutProperties(_ref, ['availableCopies', 'heldCopies', 'totalCopies', 'localeKey', 'tagElement']);

  if (availableCopies === 0 && totalCopies !== ALWAYS_AVAILABLE && totalCopies !== 0) {
    var TagElement = tagElement;
    return _react2.default.createElement(
      _reactIntl.FormattedMessage,
      { id: localeKey, values: { heldCopies: heldCopies.toString(), totalCopies: totalCopies } },
      function (message) {
        return _react2.default.createElement(
          TagElement,
          _extends({}, props, { className: 'cp-hold-counts' }),
          message
        );
      }
    );
  }
  return _react2.default.createElement('noop', null);
};

HoldCounts.propTypes = {
  localeKey: _react.PropTypes.string,
  heldCopies: _react.PropTypes.number,
  totalCopies: _react.PropTypes.number,
  availableCopies: _react.PropTypes.number,
  tagElement: _react.PropTypes.string
};

exports.default = HoldCounts;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/hold-counts/lib/components/HoldCounts.component.js
// module id = 642
// module chunks = 0 9 10 12 13